import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './TransportAccessibilityRate.css';

export interface ITransportAccessibilityRateProps {
  departmentLink: string;
  infrastructureFromBuilder?: React.ReactNode;
  onDepartmentLinkClick?(): void;
  transportAccessibility?: React.ReactNode;
}

export const TransportAccessibilityRate: React.VFC<ITransportAccessibilityRateProps> = ({
  departmentLink,
  infrastructureFromBuilder,
  onDepartmentLinkClick,
  transportAccessibility,
}) => {
  return (
    <div className={styles['container']} data-testid="TransportAccessibilityRate">
      <div className={styles['header']}>
        <UIHeading4 as="h3">Рейтинг транспортной доступности от Департамента транспорта Москвы</UIHeading4>
      </div>
      <div className={styles['description']}>
        <UIText2>
          Подробнее о рейтинге на{' '}
          <a
            className={styles['link']}
            href={departmentLink}
            onClick={onDepartmentLinkClick}
            target="_blank"
            rel="noreferrer"
          >
            сайте ведомства
          </a>
        </UIText2>
      </div>

      <div className={styles['content']}>
        <div className={styles['content-item']}>{transportAccessibility}</div>
        <div className={styles['content-item']}>{infrastructureFromBuilder}</div>
      </div>
    </div>
  );
};
